import Trip from "./Trip";

export default Trip;
